import * as React from 'react'
import { useUserData } from '../../shared-hooks/useUserData'
import { TestimonialSize } from '../Testimonial'
import { ExistingAccount } from './ExistingAccount'
import { Finished } from './Finished'
import { Generating } from './generating/Generating'
import { InsufficientTripHistory } from './InsufficientTripHistory'
import { Plaid } from './Plaid'
import { SessionPicker } from './session-picker/SessionPicker'
import { SessionPickerSegue } from './SessionPickerSegue'
import { SSOFlow } from './sso-flow/SSOFlow'
import { Stripe } from './Stripe'
import { AlwaysOnSummary } from './AlwaysOnSummary'
import { SelectCoverage } from './SelectCoverage'
import { Waitlist } from './Waitlist'

export const REQUEST_OPTIONS = {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

export enum SignupStep {
  SSO,
  Waitlist,
  Generating,
  SelectCoverage,
  AlwaysOnSummary,
  // DrivingInsights,
  ExistingAccount,
  InsufficientTripHistory,
  SessionPickerSegue,
  SessionPicker,
  Plaid,
  Stripe,
  Finished,
}

const SIGNUP_STARTING_STEP = SignupStep.SSO

type SignupFlowProps = {
  setTestimonialSize: React.Dispatch<React.SetStateAction<TestimonialSize>>
}

export const SignupFlow = ({
  setTestimonialSize,
}: SignupFlowProps): JSX.Element => {
  const [step, setStep] = React.useState(SIGNUP_STARTING_STEP)
  const [totalGuarantee, setTotalGuarantee] = React.useState(0)
  const [userPhoneNumber, setUserPhoneNumber] = React.useState('')
  const userData = useUserData()

  const setSignupStep = (step: SignupStep) => {
    if (step === SignupStep.SessionPicker) {
      setTestimonialSize(TestimonialSize.Small)
    } else {
      setTestimonialSize(TestimonialSize.Large)
    }
    setStep(step)
  }

  switch (step) {
    case SignupStep.SSO:
      return (
        <SSOFlow
          setSignupStep={setSignupStep}
          setUserPhoneNumber={setUserPhoneNumber}
        />
      )
    case SignupStep.Waitlist:
      return <Waitlist setSignupStep={setSignupStep} />
    case SignupStep.Generating:
      return <Generating userData={userData} setSignupStep={setSignupStep} />
    case SignupStep.SelectCoverage:
      return <SelectCoverage setSignupStep={setSignupStep} />
    case SignupStep.AlwaysOnSummary:
      return (
        <AlwaysOnSummary
          userData={userData}
          setTotalGuarantee={setTotalGuarantee}
          totalGuarantee={totalGuarantee}
          setSignupStep={setSignupStep}
        />
      )
    // case SignupStep.DrivingInsights:
    //   return (
    //     <DrivingInsights userData={userData} setSignupStep={setSignupStep} />
    //   )
    case SignupStep.ExistingAccount:
      return <ExistingAccount userData={userData} />
    case SignupStep.InsufficientTripHistory:
      return <InsufficientTripHistory />
    case SignupStep.SessionPickerSegue:
      return <SessionPickerSegue setSignupStep={setSignupStep} />
    case SignupStep.SessionPicker:
      return (
        <SessionPicker
          userData={userData}
          setTotalGuarantee={setTotalGuarantee}
          setSignupStep={setSignupStep}
        />
      )
    case SignupStep.Plaid:
      return <Plaid userData={userData} setSignupStep={setSignupStep} />
    case SignupStep.Stripe:
      return <Stripe setSignupStep={setSignupStep} />
    case SignupStep.Finished:
      return <Finished totalGuarantee={totalGuarantee} />
  }
}
